import React, { useState } from "react";

import styled from "styled-components";
import { BootstrapModal } from "../../BootstrapModal/Modal";
import Button from "../../Button/Button";
import { CgClose } from "react-icons/cg";
import { useGetSeoInfo, useUpdateSeo } from "../../../hooks/useContent";
import Typography from "../../Typography/Typography";
import { Wrapper } from "../../../theme/GlobalStyle";
import { SimpleSelect1 } from "../../SimpleSelect/SimpleSelect1";
import Spinner from "react-bootstrap/Spinner";
import { InputField1 } from "../../InputField1/InputField1";
import { useEffect } from "react";
import { errorMessage } from "../../../utils/message";
import { RowElement, RowLayoutStyle } from "../../ContentUnit/Sliders/AddSlide";
import { SimpleTextArea } from "../../SimpleTextArea/SimpleTextArea";

function EditSeo({ handleClose, show, item, locationSeo, IdRefrenceSeo }) {
  const {
    mutateAsync: getSeoInfo,
    isLoading: loadingReq,
    isError: reqError,
  } = useGetSeoInfo();

  const {
    mutateAsync: updateSeo,
    isLoading: reqLoading,
    isError: errorReq,
  } = useUpdateSeo();

  //   TitleSeo,EnTitleSeo,ArTitleSeo,KeywordSeo,EnKeywordSeo,ArKeywordSeo,DescriptionSeo,EnDescriptionSeo,ArDescriptionSeo,CanonicalTagSeo,
  //   Redirect3xx,IdRefrenceSeo,locationSeo,IdUser
  const [seoValue, setSeoValues] = useState({
    TitleSeo: "",
    EnTitleSeo: "",
    ArTitleSeo: "",
    KeywordSeo: "",
    EnKeywordSeo: "",
    ArKeywordSeo: "",
    DescriptionSeo: "",
    EnDescriptionSeo: "",
    ArDescriptionSeo: "",
    CanonicalTagSeo: "",
    Redirect3xx: "",
  });

  const isValidForm = () => {
    if (seoValue?.TitleSeo.length < 1) {
      errorMessage("لطفا عنوان سِو را وارد نمایید");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (isValidForm()) {
      const queryData = seoValue;
      queryData.locationSeo = locationSeo;
      queryData.IdRefrenceSeo = IdRefrenceSeo;
      updateSeo(queryData).then((res) => {
        setSeoValues({
          TitleSeo: "",
          EnTitleSeo: "",
          ArTitleSeo: "",
          KeywordSeo: "",
          EnKeywordSeo: "",
          ArKeywordSeo: "",
          DescriptionSeo: "",
          EnDescriptionSeo: "",
          ArDescriptionSeo: "",
          CanonicalTagSeo: "",
          Redirect3xx: "",
        });
        handleClose();
      });
    }
  };

  useEffect(() => {
    if (show) {
      const queryData = {
        IdRefrenceSeo,
        locationSeo,
      };
      getSeoInfo(queryData).then((response) => {
        const reciveData = response?.data?.seos[0];
        setSeoValues({
          TitleSeo: reciveData?.NameShopForSeo
            ? reciveData?.NameShopForSeo
            : "",
          EnTitleSeo: reciveData?.NameShopForSeoEnglish
            ? reciveData?.NameShopForSeoEnglish
            : "",
          ArTitleSeo: reciveData?.NameShopForSeoLanguage
            ? reciveData?.NameShopForSeoLanguage
            : "",
          KeywordSeo: reciveData?.KeywordShopForSeo
            ? reciveData?.KeywordShopForSeo
            : "",
          EnKeywordSeo: reciveData?.KeywordShopForSeoEnglish
            ? reciveData?.KeywordShopForSeoEnglish
            : "",
          ArKeywordSeo: reciveData?.KeywordShopForSeoLanguage
            ? reciveData?.KeywordShopForSeoLanguage
            : "",
          DescriptionSeo: reciveData?.DescriptionShopForSeo
            ? reciveData?.DescriptionShopForSeo
            : "",
          EnDescriptionSeo: reciveData?.DescriptionShopForSeoEnglish
            ? reciveData?.DescriptionShopForSeoEnglish
            : "",
          ArDescriptionSeo: reciveData?.DescriptionShopForSeoLanguage
            ? reciveData?.DescriptionShopForSeoLanguage
            : "",
          CanonicalTagSeo: reciveData?.CanonicalTagSeo
            ? reciveData?.CanonicalTagSeo
            : "",
          Redirect3xx: reciveData?.Redirect3xx ? reciveData?.Redirect3xx : "",
        });
      });
    }
  }, [show]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setSeoValues({ ...seoValue, [name]: value });
  };

  return (
    <BootstrapModal
      modaltitle="ویرایش سِِو"
      handleClose={handleClose}
      show={show}
      size="lg"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="modal-body">
        <UpdateSeoStyle>
          {loadingReq ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <SeoWrapper>
              <InputField1
                name={"TitleSeo"}
                onChange={handleChange}
                value={seoValue?.TitleSeo}
                label={"عنوان"}
              />

              <InputField1
                name={"EnTitleSeo"}
                onChange={handleChange}
                value={seoValue?.EnTitleSeo}
                label={"عنوان انگلیسی"}
              />

              <InputField1
                name={"ArTitleSeo"}
                onChange={handleChange}
                value={seoValue?.ArTitleSeo}
                label={"عنوان عربی"}
              />

              <InputField1
                name={"KeywordSeo"}
                onChange={handleChange}
                value={seoValue?.KeywordSeo}
                label={"کلمات "}
              />

              <InputField1
                name={"EnKeywordSeo"}
                onChange={handleChange}
                value={seoValue?.EnKeywordSeo}
                label={"کلمات انگلیسی"}
              />

              <InputField1
                name={"ArKeywordSeo"}
                value={seoValue?.ArKeywordSeo}
                onChange={handleChange}
                label={"کلمات عربی"}
              />

              <SimpleTextArea
                name={"DescriptionSeo"}
                value={seoValue?.DescriptionSeo}
                label={"توضیحات فارسی"}
                onChange={handleChange}
                rows={4}
              />

              <SimpleTextArea
                name={"EnDescriptionSeo"}
                onChange={handleChange}
                value={seoValue?.EnDescriptionSeo}
                label={"توضیحات انگلیسی"}
                rows={4}
              />

              <SimpleTextArea
                name={"ArDescriptionSeo"}
                label={"توضیحات عربی"}
                value={seoValue?.ArDescriptionSeo}
                onChange={handleChange}
                rows={4}
              />

              <InputField1
                name={"CanonicalTagSeo"}
                onChange={handleChange}
                value={seoValue?.CanonicalTagSeo}
                label={"تگ"}
              />
              <InputField1
                name={"Redirect3xx"}
                value={seoValue?.Redirect3xx}
                onChange={handleChange}
                label={"Redirect3xx"}
              />
            </SeoWrapper>
          )}
        </UpdateSeoStyle>
      </div>
      <div className="modal-footer">
        <Button
          bgColor={"#4c78a9"}
          small={"100px"}
          className="m-r-1"
          onclick={(e) => {
            !reqLoading && handleSubmit();
          }}
          color="#fff"
        >
          {reqLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Typography size={"15px"} primary={"#fff"}>
              ویرایش
            </Typography>
          )}
        </Button>
        <Button
          className={"mr-2"}
          style={{ marginRight: "10px" }}
          color={"#fff"}
          bgColor={"#f1416c"}
          small={"100px"}
          onclick={handleClose}
        >
          <Typography size={"15px"} primary={"#fff"}>
            انصراف
          </Typography>
        </Button>
      </div>
    </BootstrapModal>
  );
}

const UpdateSeoStyle = styled.div`
  width: 100%;
  /* height: 80px; */
  height: 40vh;
  background-color: #fff;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
`;

const SeoWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  overflow-y: scroll;
  padding-left: 1rem;
  flex-direction: column;
`;

const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 1rem;
`;

export default EditSeo;
